<script>
    import groups from "./stores/groups";
    import {groupsRemoveMobiles} from './requests';
    import MobilesContainer from "./components/MobilesContainer.svelte";

    export let badNumbers = [];
    export let closeCallback = null;

    let showInvalidMobiles = false;
    let totalAffectedGroups = 0;
    let totalRemovedPhones = 0;
    let affectedGroups = [];
    let phonesRemoved = false;

    const Close = () => {
        if (closeCallback) {
            closeCallback();
        }
    }

    const removeBadPhones = async () => {

        const [err, res] = await groupsRemoveMobiles(badNumbers);

        totalAffectedGroups = res.total_groups;
        totalRemovedPhones = res.total_mobiles;
        affectedGroups = res.affected_groups;

        if (affectedGroups.length) {
            affectedGroups.map(item => {
                let group = $groups.list.find(x => x.id == item.id);
                if (group) {
                    group.total_mobiles = item.total_mobiles;
                }
            });
        }

        phonesRemoved = true;
    };

</script>
<div class="popup-overlay visible">
    <div class="modal modal-xs">
        <div class="modal-header">
            <div class="modal-title">
                Αφαίρεση απορριφθέντων αριθμών κινητών
            </div>
            <div class="controls-right">
                <span on:click="{ Close }"><i class="fa fa-times"></i></span>
            </div>
        </div>
        <div class="modal-body">
            {#if !phonesRemoved}
                <p>
                    Θα αφαιρεθούν οριστικά <strong>{ badNumbers.length }</strong> αριθμοί κινητών που βρέθηκαν στις
                    ανεπιτυχής αναφορές του μηνύματος από όλες τις ομάδες σας.
                </p>
                <p class="text-center">
                    <span class="text-link" title="εμφάνιση τηλεφώνων"
                          on:click={ () => showInvalidMobiles = !showInvalidMobiles }>εμφάνιση τηλεφώνων
                    </span>
                </p>
                <hr>
                {#if showInvalidMobiles}
                    <MobilesContainer mobiles="{ badNumbers }" label="απορριφθέντες αριθμοί"/>
                {/if}
                <button class="btn btn-primary btn-block" on:click={ removeBadPhones }>Αφαίρεση</button>
            {:else}
                {#if totalRemovedPhones}
                    <p>
                        Αφαιρέθηκαν <strong>{ totalRemovedPhones }</strong> αριθμοί κινητών από
                        <strong>{ affectedGroups.length }</strong> ομάδες.
                    </p>
                    {#if affectedGroups.length}
                        <table class="table table-bordered table-list table-data mrg-b-none">
                            <thead>
                            <tr>
                                <td>Ομάδα</td>
                                <td>Αφαιρέθηκαν</td>
                            </tr>
                            </thead>
                            <tbody>
                            {#each affectedGroups as group}
                                <tr>
                                    <td>{ group.name }</td>
                                    <td class="text-right">{ group.removed_mobiles}</td>
                                </tr>
                            {/each}
                            </tbody>
                        </table>
                    {/if}
                {:else}
                    <p>
                        Δεν βρέθηκαν ομάδες που να περιέχουν τους αριθμούς κινητών.
                    </p>
                {/if}
            {/if}
        </div>
        <div class="modal-footer text-right">
            <button class="btn btn-default" on:click="{ Close }">Κλείσιμο</button>
        </div>
    </div>
</div>